import { FC, useCallback, useEffect, useState } from 'react';

import { useIsUnsupported } from '@rikstv/play-common/src/components/coverPage/useIsUnsupported';
import { AssetDetails } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';
import { useAssetDetails } from '@rikstv/play-common/src/forces/assetDetails/useAssetDetails';
import { useAuthToken } from '@rikstv/play-common/src/hooks/useAuthToken';

import { PlaybackContext } from './forces/PlaybackContext';
import { LazyLoadedPlayer } from './LazyLoadedPlayer';
import { PlayerProps } from './Player';

// TODO (@tolu): error handling needs some work here. Outdated tokens for instance.

export const FullScreenPlayer: FC<{ assetId?: string; onClose: () => void }> = ({ assetId, onClose }) => {
  const token = useAuthToken();

  const [contentId, setContentId] = useState(assetId);
  useEffect(() => setContentId(assetId), [assetId]);

  // Setting "keepPreviousData=true" avoids unmounting player when loading nextUp-asset (binge)
  const { data: asset, mutate } = useAssetDetails(contentId, { keepPreviousData: true });
  const onPlayNextReady = useCallback((asset: AssetDetails) => setContentId(asset.id), [setContentId]);
  const Unsupported = useIsUnsupported();

  // force fresh progress data
  useEffect(() => {
    mutate();
  }, [mutate]);

  if (!assetId) {
    return null;
  }
  if (!token) {
    return <p>token not valid</p>;
  }
  if (Unsupported) {
    return <Unsupported />;
  }
  if (!asset) {
    return <p>no asset</p>;
  }
  if (asset.streamingMode !== 'OnDemand') {
    return <p>only support VOD right now</p>;
  }
  const props: PlayerProps = {
    playable: asset,
    posterUrl: asset.posterUrl,
    autoPlay: true,
    onCloseModalPlayer: onClose,
    onPlayNextReady,
  };
  return (
    <PlaybackContext.Provider value={{ setAssetId: setContentId }}>
      <LazyLoadedPlayer {...props} />
    </PlaybackContext.Provider>
  );
};
